/* src/app/activation-page/activation-page.component.scss */
.activation {
  height: 100dvh;
  padding: 1rem;
  display: grid;
  place-content: center;
}
.activation .container {
  background: rgba(255, 255, 255, 0.8);
  border: 0.1rem solid white;
  border-radius: 1rem;
  -webkit-backdrop-filter: blur(0.5rem);
  backdrop-filter: blur(0.5rem);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 500px;
  width: 100%;
  margin-inline: auto;
}
.activation .container .logo {
  width: 50%;
  max-width: 200px;
}
.activation .container .title {
  text-align: center;
  text-wrap: pretty;
  padding: 0.5rem 0;
}
.error {
  color: red;
  font-size: 0.8rem;
  text-align: center;
}
.input {
  width: 100%;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 2px solid white;
  text-align: center;
}
.input:focus-visible {
  outline: none;
  border: 2px solid #1289ad;
}
.button {
  width: 100%;
  padding: 1rem;
  border-radius: 1000rem;
  background: #4ac8f3;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  border: 2px solid #4ac8f3;
  transition: all 150ms;
}
.button:focus-visible {
  outline: none;
  border: 2px solid #1289ad;
}
.button:disabled {
  cursor: not-allowed;
  filter: grayscale(0.5);
}
.blurred-img {
  position: absolute;
  inset: 0;
  z-index: -1;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=activation-page.component.css.map */
